var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1192_6183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.148148,
    width: 40,
    height: 40,
    rx: 14,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1192_6183)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.148148,
    width: 40,
    height: 40,
    fill: "#19D3C5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2163 17.318C15.525 17.657 16.05 17.6815 16.3889 17.3729L18.8311 15.1492V27.3181C18.8311 27.7765 19.2027 28.1481 19.6612 28.1481C20.1196 28.1481 20.4912 27.7765 20.4912 27.3181V15.1492L22.9334 17.3729C23.2724 17.6815 23.7974 17.657 24.106 17.318C24.4146 16.979 24.3901 16.454 24.0511 16.1454L19.6612 12.1481L15.2712 16.1454C14.9323 16.454 14.9077 16.979 15.2163 17.318Z",
    fill: "#19D3C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUp);
export default __webpack_public_path__ + "static/media/icUp.6b1e77d30161e7a17268e7c9a68b3228.svg";
export { ForwardRef as ReactComponent };